module.exports = __webpack_public_path__ + "img/LE BLE D’OR.2bd73cbd.svg";